import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => {
        setOpen(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-23" data-mp="116cyzt2ybpaw">
      <AnimatePresence data-id="element-24" data-mp="1awphzgv4baex">
        {open && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_18px_40px_-14px_rgba(10,26,51,0.45)] sm:w-[340px]" data-id="element-25" data-mp="1ax7nl43o70zi">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-paper object-contain" data-id="element-26" data-mp="28jy7ro25j5mq" />
            <div className="min-w-0" data-id="element-27" data-mp="23kbmcrc66j2u">
              <p className="text-sm leading-snug text-ink" data-id="element-28" data-mp="23nhc88smhozm">
                <span className="font-bold" data-id="element-29" data-mp="2anjjthbtab8c">{buyer.name}</span> from <span className="font-bold" data-id="element-30" data-mp="2aqxj2gp6i4bk">{buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-31" data-mp="2fpr0gk7l6fh0">just purchased the Safe Spine Method™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-brand" data-id="element-32" data-mp="2kkoa9tcowsuy">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="2pjran0hq6awl" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Dismiss notification" data-id="element-34" data-mp="1wxy4qi14ug5l">
              <XIcon className="h-4 w-4" data-id="element-35" data-mp="196j18lxmdssr" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}